'use strict';

angular
	.module('bringgApp')
	.controller('ChangeSubscriptionTypeController', function (
		$scope,
		Authentication,
		Payments,
		$uibModalInstance,
		currentSubscription,
		toastr
	) {
		$scope.data = {};
		$scope.current_user = Authentication.currentUser();
		$scope.data.originalSubscriptionType = currentSubscription;
		$scope.data.selectedSubscriptionType = currentSubscription;

		$scope.handleChangeSubscriptionTypeResult = function (result) {
			if (result.success) {
				toastr.success('Your plan was successfully changed.');
				$uibModalInstance.close();
			} else {
				if (result.message) {
					toastr.error(result.message);
				} else {
					toastr.error('There was a problem changing your subscription type.');
				}
			}
		};

		$scope.handleSaveClick = function () {
			if ($scope.data.originalSubscriptionType === $scope.data.selectedSubscriptionType) {
				return; //this should not happen the view should be disabled
			}

			Payments.changeSubscriptionType(
				{ selected_subscription_type: $scope.data.selectedSubscriptionType },
				$scope.handleChangeSubscriptionTypeResult
			);
		};

		$scope.handleCancelClick = function () {
			$uibModalInstance.dismiss();
		};
	});
